import React, { useContext, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import firebase from 'firebase/app';
import "firebase/auth";
import './LogIn.css';
import firebaseConfig from '../../firebase.config';
import { userContext } from '../../App';
import { Form ,Button, Row, Col, Container} from 'react-bootstrap';
import GoogleButton from 'react-google-button';


if (firebase.apps.length === 0) {
  firebase.initializeApp(firebaseConfig);
}

const LogIn = () => {

  var provider = new firebase.auth.GoogleAuthProvider();

  const [logedInUser, setlogedInUser] = useContext(userContext);
  const history = useHistory();
  const location = useLocation();
  let { from } = location.state || { from: { pathname: "/" } };

  const [user, setUser] = useState({
    isSingIn: false,
    name: '',
    email: '',
    photo: '',

  })
  console.log(user)
  const SingInWithPopUp = () => {

    firebase.auth()
      .signInWithPopup(provider)
      .then((result) => {
        var { displayName, email, photoURL } = result.user;
        const UserInfo = {
          isSingIn: true,
          name: displayName,
          email: email,
          photo: photoURL

        }
        setUser(UserInfo)
        setlogedInUser(UserInfo);
        localStorage.setItem("user",JSON.stringify(UserInfo));
        history.replace(from)
        // ...
      }).catch((error) => {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        // The email of the user's account used.
        var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        var credential = error.credential;
        // ...
      });

  }

  // const CheckEmailPassword = () => {
  //     console.log("email")
  // }


  return (

    
      <div className="container mt-5">
        <div className="row">
          <div className="col-md-12 ">
        <Form  className="responsive w-50 m-auto ">
          <Form.Group  controlId="formBasicEmail">
            <Form.Control className="ipt" type="name" required placeholder="Enter Name" />
          </Form.Group>

          <Form.Group controlId="formBasicPassword">
            <Form.Control type="email" required placeholder="Email" />
          </Form.Group>

          <Form.Group controlId="formBasicPassword">
            <Form.Control type="password" required placeholder="Password" />
          </Form.Group>

          <Form.Group controlId="formBasicPassword">
            <Form.Control type="password" required placeholder="Confirm Password" />
          </Form.Group>
          <Button className="w-100" variant="danger" type="submit">
            Submit
          </Button>
          <GoogleButton onClick={SingInWithPopUp} 
          type="dark"  className="w-100 mt-2 ">
            SingInWithGoogle
            
          </GoogleButton>
         
        </Form>
        </div>
        </div>  
    

        </div>


  


  );
};

export default LogIn;